import Logo from "../components/Logo";

const DashboardHome = () => {
  return (
    <div className="hidden w-full h-screen md:flex flex-col items-center  justify-center  "> 
      <div className="blink"><Logo /></div>
    </div>
  );
};

export default DashboardHome;
